import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import { colors, devices } from 'styles';

export const BigImageWrapper = styled(Box)`
  overflow: hidden;
  border-radius: 8px;
  height: 340px;
  max-width: 292px;

  @media (max-width: 1200px) {
    max-width: 220px;
    height: 272px;
  }

  & img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    max-width: 100%;
    height: 100%;
  }
`;

export const SmallImageWrapper = styled(Box)`
  overflow: hidden;
  border-radius: 8px;
  height: 206px;
  width: 292px;

  @media (max-width: 1200px) {
    max-width: 220px;
    height: 186px;
  }

  & img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    max-width: 100%;
  }
`;

export const HeroTitle = styled(Typography)`
  font-weight: 700;
  font-size: 40px;
  line-height: 120%;
  color: ${colors.white};

  @media (${devices.sm}) {
    margin-right: 24px;
  }

  @media (${devices.md}) {
    margin-right: 0;
  }

  @media (${devices.lg}) {
    font-size: 56px;
  }
`;

export const Container = styled(Box)`
  position: relative;
  margin: 0 auto;
  max-width: 1280px;
  z-index: 3;
  width: 100%;
  padding: 48px 32px 156px;

  @media (${devices.lg}) {
    padding: 160px 32px 244px;
  }
`;

export const FirstSectionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;

  @media (${devices.sm}) {
    align-items: flex-start;
    flex-direction: row;
  }

  @media (${devices.md}) {
    display: block;
    max-width: 480px;
  }

  @media (${devices.lg}) {
    max-width: 520px;
  }
`;

export const ButtonWrapper = styled(Box)`
  display: flex;
  flex-direction: column;

  @media (${devices.md}) {
    flex-direction: row;
  }
`;

export const BlueButtonWrapper = styled(Box)`
  margin-right: 0px;
  margin-bottom: 16px;
  width: 100%;

  /* & button {
    width: 100%;
  } */

  @media (${devices.md}) {
    margin-right: 16px;
    margin-bottom: 0;
    width: auto;

    /* & button {
      width: auto;
    } */
  }
`;

export const HeroDescription = styled(Typography)`
  margin: 24px 0 32px;
  color: ${colors.white};
  font-size: 16px;
  line-height: 150%;
  white-space: pre-line;

  @media (${devices.sm}) {
    margin: 0 0 24px;
  }

  @media (${devices.md}) {
    margin: 24px 0 32px;
  }
`;

export const WebImageWrapper = styled(Box)`
  position: absolute;
  top: 32%;
  transform: translateY(-50%), rotate(180deg);
  left: 0;

  img {
    max-width: 400px;
    display: block;

    @media (${devices.md}) {
      max-width: 900px;
      width: 900px;
    }
  }

  @media (${devices.xs}) {
    top: 27%;
  }

  @media (${devices.sm}) {
    top: 32%;
  }

  @media (${devices.md}) {
    top: 60%;
    transform: translateY(-50%);
  }
`;

export const DescriptionContainer = styled(Box)`
  max-width: 100%;

  @media (${devices.sm}) {
    max-width: 373px;
  }

  @media (${devices.md}) {
    max-width: 480px;
  }

  @media (${devices.lg}) {
    max-width: 520px;
  }
`;

export const HeroSubTitle = styled(Typography)`
  max-width: 1000px;
  font-size: 32px;
  line-height: 120%;
  color: ${colors.white};
  text-align: center;
  font-weight: 700;
  z-index: 3;

  @media (${devices.md}) {
    font-size: 36px;
  }
`;

export const ItemsWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: column;

  @media (${devices.sm}) {
    flex-direction: row;
    justify-content: center;
    gap: 48px;
  }
`;

export const Item = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  margin-bottom: 48px;

  @media (${devices.sm}) {
    margin-bottom: 0;
    max-width: 224px;
  }

  @media (${devices.md}) {
    max-width: 368px;
  }

  img {
    display: block;
  }
`;

export const ItemTitle = styled(Typography)`
  margin: 24px 0;
  max-width: 368px;
  font-size: 24px;
  line-height: 140%;
  color: ${colors.white};
  text-align: center;
  font-weight: 700;
  max-width: 420px;

  @media (${devices.sm}) {
    max-width: 420px;
  }
`;

export const ItemText = styled(Typography)`
  max-width: 368px;
  font-size: 16px;
  line-height: 150%;
  color: ${colors.white};
  text-align: center;

  @media (${devices.sm}) {
    max-width: 420px;
  }
`;
